import _tokens from './tokens.js'
import { extractUnits } from './utils.js'
import { UnitType } from '@exodus/currency'

const name = 'cardano'
const displayName = 'Cardano'
const ticker = 'ADA'
const displayTicker = 'ADA'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#4A6EC3'
const gradientColors = ['#4A6EC3', '#3384BF']
const gradientCoords = { x1: '106.38%', y1: '115.934%', x2: '-33.63%', y2: '-54.191%' }
const chainBadgeColors = ['#4A6EC3', '#0033AD']

const units = {
  lovelaces: 0,
  ADA: 6,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://cardanoscan.io/address/${address}/`,
  txUrl: (txId) => `https://cardanoscan.io/transaction/${txId}/`,
}
const info = {
  description:
    'Cardano is an open source project and decentralized public blockchain. It is building a smart contract platform and uses a proof of stake algorithm to reach consensus about the network.',
  reddit: 'https://www.reddit.com/r/cardano/',
  twitter: 'https://twitter.com/cardano',
  website: 'https://www.cardano.org/',
  telegram: 'https://t.me/CardanoAnnouncements',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export const cardano = asset

export const tokens = _tokens.map((token) => {
  const units = extractUnits(token)
  return {
    ...token,
    // name,
    // displayName,
    // decimals,
    // ticker,
    // assetIndex,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetType: 'CARDANO_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    currency: UnitType.create(units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    info: token.info || {},
    isBuiltIn: true,
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    toString: () => token.name,
    units,
  }
})

export default [asset, ...tokens]
